<template>
  <div class="hybrid-view" ref="hybridView">
    <div class="collection-title" ref="collectionTitle"></div>
  <div
    v-if="imageResources.length > 0"
    class="display-group-data"
    ref="displayGroupData"
  >
    <div
      v-show="editCollectionSearchDisplayType === 'editCollectionGrid'"
      class="format-edit-collection"
    >
      <div
        v-for="(item, index) in imageResources"
        :key="index"
        :id="'editItem' + item.id"
      >
        <div
          class="collection-grid-items"
        >
        <div
          :id="'removeItem' + item.id"
          class="delete circle"
          @click="handleRemoveItems(item)"
          @mouseover="handleHover(item)"
          @mouseleave="handleHoverLeave(item)"
        >
          <div class="icon-size-del">
            <v-img
              :src="require('@/assets/svg/SVG/x.svg')"
              class="list-icon"
            />
          </div>
        </div>  
          <div class="image">
            <v-img
              :src="item.imageUri"
              max-width="200"
              max-height="50"
              alt="Download"
            />
          </div>
          <div class="label">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div v-show="editCollectionSearchDisplayType === 'editCollectionList'">
      <div
        v-for="(item, index) in imageResources"
        :id="'editItem' + item.id"
        :key="index"
        class="collection-list-items"
        @mouseover="handleHover(item)"
        @mouseleave="handleHoverLeave(item)"
        @click="handleRemoveItems(item)"
      >
      <div>
      <div
          :id="'removeItem' + item.id"
          class="delete circle"
          @click="handleRemoveItems(item)"
          @mouseover="handleHover(item)"
          @mouseleave="handleHoverLeave(item)"
        >
          <div class="icon-size-del">
            <v-img
              :src="require('@/assets/svg/SVG/x.svg')"
              class="list-icon"
            />
          </div>
        </div> 
        </div>
        <div class="left-side">
          <div class="image-list">
            <img
              :src="item.imageUri"
              alt="image"
              class="list-image"
            >
          </div>
          <div class="label">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isAddResource" ref="dragSizer" class="drag-sizer" @touchstart="handleStart" @touchmove="handleDrag" @touchend="handleTouchEnd" @mousedown="handleMouseStart" @mouseup="handleMouseUp">
      <div class="drag-line"></div>
    </div>
  <div class="collections-container-add" v-if="isAddResource">
    <div
      class="add-resource-box"
      ref="collectionsContainerAdd"
    >
      <CreateItem        
        v-for="(resource, index) in resources"
        :key="index"
        :num="index"
        :resource="resource"
        :display="'full'"
      />
    </div>
  </div>
</div>
</template>

<script>
import { useRMTStore } from '@/store/RMTStore';
import { gsap } from 'gsap';
import { mapStores } from 'pinia';
import CreateItem from './CreateItem.vue';

export default {
  watch: {
    isCollectionItemsChanged (to, from) {
      const RMTStore = useRMTStore();
      if (to != from && !RMTStore.inCreateCollectionMode) {
        this.RMTStore.createdCollectionItems.forEach((element) => {
          if (!this.imageData.includes(element)) {
            this.imageData.push(element);
          }
        });
        return this.imageData;
      }
    }
  },
  data () {
    return {
      imageUrl: [],
      imageData: [],
      modifiedResources: []
    };
  },
  components: {
    CreateItem,
  },
  computed: {
    ...mapStores(useRMTStore),
    isAddResource () {
      const RMTStore = useRMTStore();
      return RMTStore.isAddResource;
    },
    editCollectionSearchDisplayType () {
      return this.RMTStore.getEditCollectionSearchDisplayType;
    },
    resources () { 
      this.modifiedResources = [];
      const existingId = this.imageData.map((item) => {
        return item.id;
      });
      this.RMTStore.resources.forEach((element) => {
        if (!existingId.includes(element.id)) {
          this.modifiedResources.push(element);
        }
      });
      
      return this.modifiedResources;
    },
    imageResources () {
      if (this.imageData === undefined) {
        return [];
      } 
      return this.imageData;
    }
  },
  // created () {
  //   this.imageData = this.RMTStore.uploadedFiles;
  // },
  mounted () {
    if (this.RMTStore.selectedCollections.length === 0) {return;}
    this.imageData = this.RMTStore.selectedCollections[0].resources;
  },
  methods: {
    handleHover (resource) {
      if (!this.RMTStore.displayCollectionItems.includes(resource)) {
        const itemId = '#removeItem' + resource.id;
        gsap.to(itemId, {
          backgroundColor: 'lightgrey',
          duration: .1
        });
      }
    },
    handleHoverLeave (resource) {
      if (!this.RMTStore.displayCollectionItems.includes(resource)) {
        const itemId = '#removeItem' + resource.id;
        gsap.to(itemId, {
          backgroundColor: '#ffffff',
          duration: .1
        });
      }
    },
    handleRemoveItems (item) {
      const removeUploadedItem= this.imageData.filter(function (element) {
        return element.id != item.id;
      });
      this.imageData = removeUploadedItem;
      this.modifiedResources.push(item);
      this.RMTStore.editCollectionItems.push(item);
      this.RMTStore.editCollectionId.push(item.id);
      const removeItem = this.RMTStore.createdCollectionItems.filter(function (element) {
        return element.id != item.id;
      });
      const removeId = this.RMTStore.createdCollectionId.filter(function (element) {
        return element != item.id;
      });
      this.RMTStore.createdCollectionItems = removeItem;
      this.RMTStore.createdCollectionId = removeId;
    },
    formatImageData (element) {
      return element.downloadUri;
    },
    handleDrag (e) {
      let py = (e.touches) ? e.touches[0].pageY :  e.pageY;
      let d = py - this.$refs.hybridView.offsetTop - this.$refs.collectionTitle.clientHeight;

      // upper limit
      if (d <= 0) {
        this.$refs.displayGroupData.style.height = '0';
        return;
      }

    // percentages of chart and table view 58 42
    // lower limit
    if (d > (this.$refs.hybridView.clientHeight - this.$refs.collectionTitle.clientHeight) * .58) {
      this.$refs.displayGroupData.style.height = ((this.$refs.hybridView.clientHeight - this.$refs.collectionTitle.clientHeight) * .58) + 'px';
      return;
    }

      this.$refs.displayGroupData.style.height = d + 'px';
      this.$refs.collectionsContainerAdd.style.maxHeight = this.$refs.hybridView.clientHeight - this.$refs.collectionTitle.clientHeight - d - this.$refs.dragSizer.clientHeight + 'px';

    },
    handleStart () {
      this.startY = this.$refs.dragSizer.offsetTop - this.$refs.hybridView.offsetTop;
      this.$refs.dragSizer.style.backgroundColor = 'gray';
    },

    handleTouchEnd () {
      this.$refs.dragSizer.style.backgroundColor = 'whitesmoke';
    },

    handleMouseStart (e) {
      e.preventDefault(); 
      this.handleStart();
      window.addEventListener('mousemove', this.handleDrag);
      window.addEventListener('mouseup', this.handleMouseUp);
    },
    
    handleMouseUp () {
      this.handleTouchEnd();
      window.removeEventListener('mousemove', this.handleDrag);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  },
};
</script>

<style scoped>
.collections-item-container {
  cursor: pointer;
}
.format-edit-collection {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.format-edit-collection-list {
  display: grid;
  grid-template-columns: auto;
}

.collection-list-items {
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  justify-content: space-between;
  cursor: pointer;
  border: 1px solid #f5f5f5;
}

.list-collections {
  display: flex;
  flex-direction: row;
}

.collection-grid-items {
  height: 200px;
  padding: 2px 2px 10px;
  margin-bottom: 5px;
  margin-left: 2px;
  margin-right: 2px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  border: 1px solid white;
}
.image {
	height: 50%;
  width: 50%;
  scale: 2;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 2px 4px 43px -32px #a6b5a6;
}

.label {
  pointer-events: none;
  padding: 10px 10px 10px 10px;
  font-size: 0.8em;
  font-weight: bold;
}

.left-side {
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.list-image {
  object-fit: contain;
  height: 55px;
}
.image-list {
  height: 55px;
}
.collection-item {
  width: calc((100% / 5) - 5px);
  /*  max-width: 55px;*/
  aspect-ratio: 1 / 1;
  background-color: #9c9c9c;
  margin: 2px;
  transition: width 0.2s, height 0.2s, margin 0.2s;
}

.collection-item-expand {
  width: calc((100% / 4) - 4px);
  aspect-ratio: 1 / 1;
  /*  max-width: 150px;*/
  background-color: #9c9c9c;
  margin: 2px;
  transition: width 0.2s, height 0.2s, margin 0.2s;
}

.display-group-data {
  overflow-y: auto;
  width: 100%;
  flex: auto;
  /* padding: 3px 0; */
  max-height: 500px;
}
.circle,
.delete {
  cursor: pointer;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  display: flex;
  align-self: flex-end;
  justify-content: flex-end;
}
.icon-size-del {
  width: 13px;
}
.circle {
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.collections-container-add {
  width: 100%;
  overflow-y: auto;
  max-height: 500px;
/*  min-height: 500px;*/
  /*background-color: #727272;*/
}
.drag-sizer {
  cursor: row-resize;
  width: 100%;
  height: 20px;
  background-color: whitesmoke;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .1s background-color;
}

.drag-sizer:hover {
  background-color: #e7e7e7;
}

.drag-line {
  height: 5px;
  width: 100px;
  background-color: lightgray;
  border-radius: 3px;
}
.add-resource-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
}

.display-group-data::-webkit-scrollbar,
.collections-container-add::-webkit-scrollbar {
  width: 8px;

}
.display-group-data::-webkit-scrollbar-track,
.collections-container-add::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.0);
}
.display-group-data::-webkit-scrollbar-thumb,
.collections-container-add::-webkit-scrollbar-thumb {
  margin: 2px;
/*  background-color: #ffffff;*/
    background-color: #d0d0d0;
  border-radius: 10px;
/*  box-shadow: inset 0 0 10px 10px #d0d0d0;*/
  border: solid 3px transparent;
}
.hybrid-view {
  max-height: 1080px;
}
</style>
